import { render, staticRenderFns } from "./NewCommentInput.vue?vue&type=template&id=a5a95148&scoped=true&"
import script from "./NewCommentInput.vue?vue&type=script&lang=js&"
export * from "./NewCommentInput.vue?vue&type=script&lang=js&"
import style0 from "./NewCommentInput.vue?vue&type=style&index=0&id=a5a95148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a95148",
  null
  
)

export default component.exports